import {
  createAnalytics,
  createIdentityJwtTokenGetter
} from '@3plearning/mx-teacher-analytics';
import appEvents from './events';

const APP_NAME = 'upf-assign';
const TEACHER_TOTTER_PRODUCT = 'mathletics';
const CORE_GROUP = 'core';

function resolveEnabledGroups(trackingGroups) {
  if (!trackingGroups) {
    return null;
  }

  const groups = trackingGroups
    .split(',')
    .map((group) => group.trim())
    .filter(Boolean);

  return [...groups, CORE_GROUP];
}

// Package throws if teacher-totter is enabled without a syncUrl; fall back to off.
export default function buildAnalyticsClient(config) {
  const {
    environment,
    posthogEnabled,
    trackingGroups,
    teacherTotterEnabled,
    teacherTotterSyncUrl,
    identityGatewayUrl,
    getAppAuthToken
  } = config;

  const posthog = posthogEnabled ? { enabled: true } : { enabled: false };
  const teacherTotterOn = Boolean(teacherTotterEnabled && teacherTotterSyncUrl);
  const getTeacherTotterAuthToken = createIdentityJwtTokenGetter({
    identityGatewayUrl,
    getAppAuthToken
  });

  const analyticsConfig = {
    app: APP_NAME,
    environment: environment || 'production',
    providers: {
      posthog,
      teacherTotter: {
        enabled: teacherTotterOn,
        syncUrl: teacherTotterSyncUrl,
        product: TEACHER_TOTTER_PRODUCT,
        getAuthToken: getTeacherTotterAuthToken
      }
    },
    enabledFeatureGroups: resolveEnabledGroups(trackingGroups),
    events: appEvents
  };

  try {
    const client = createAnalytics(analyticsConfig);

    // Warm the identity JWT so the first event sends without waiting on auth.
    if (teacherTotterOn) {
      getTeacherTotterAuthToken();
    }

    return client;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      '[analytics] Initialisation failed; continuing with teacher-totter disabled.',
      error
    );

    return createAnalytics({
      ...analyticsConfig,
      providers: {
        ...analyticsConfig.providers,
        teacherTotter: {
          ...analyticsConfig.providers.teacherTotter,
          enabled: false
        }
      }
    });
  }
}
